import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Actions from "../../../../../../redux/actions";
import {
  getServiceProviderRequestChatById,
  getServiceProviderUserChatRequestAction,
  updateRequestStatusAction,
} from "../../../../../../redux/services/service-provider-user-chat/serviceProviderUserChatServices";
import useLocalStorage from "../../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../../constants/config/appConfig";
import ChatComponent from "../../../../../common/chat-component/ChatComponent";
import "react-chat-elements/dist/main.css";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../../../constants";
import { baseRouteMaker } from "../../../../../../constants/routeConsts";
import useDebounce from "../../../../../../hooks/useDebounce";
import Spinner from "../../../../../common/spinner/Spinner";

const ChatRequest = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* navigate dependencies */
  const navigate = useNavigate();
  /* navigate dependencies */

  /*loading dependencies */
  const [loading, setLoading] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  /*loading dependencies */

  /* local storage dependencies */
  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);
  /* local storage dependencies */

  /* table dependencies */
  const {
    serviceProviderUserChatRequest,
    serviceProviderChatMessagesRequestById,
  } = useSelector((state) => state.serviceProviderUserChat);
  const [searchValue, setSearchValue] = useState("");
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    dispatch(
      Actions.createAction(
        Actions.GET_SERVICE_PROVIDER_USER_CHAT_DETAILS_BY_ID,
        { serviceProviderUserChatDetailsById: {} }
      )
    );
    dispatch(
      Actions.createAction(Actions.GET_SERVICE_PROVIDER_USER_CHAT_LIST, {
        serviceProviderUserChat: {
          data: [],
        },
      })
    );
    const dataToBeSent = {
      userId: userSession?.userId,
      search:debouncedSearchValue
    };
    dispatch(getServiceProviderUserChatRequestAction(dataToBeSent, setTableLoader));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchValue]);

  const onChatClicked = (element) => {
    let dateToBeSent = {
      id: element._id,
      user: element,
    };
    dispatch(getServiceProviderRequestChatById(setLoading, dateToBeSent));
  };

  const onRequestStatusChanged = (id, status, setLoading, setOpen) => {
    const dataToBeSent = {
      selectedRequestId: id,
      status,
    };
    dispatch(updateRequestStatusAction(dataToBeSent, setLoading, setOpen)).then(()=>{
      handleGetTableData();
    })
  };

  return (
    <>
      <ChatComponent
        chatList={serviceProviderUserChatRequest?.data?.map((element) => ({
          ...element?.customer_id,
        }))}
        chatMessages={[]}
        requestMessage={
          serviceProviderChatMessagesRequestById &&
          serviceProviderChatMessagesRequestById?.response !== null &&
          serviceProviderChatMessagesRequestById?.response !== undefined
            ? serviceProviderChatMessagesRequestById
            : {}
        }
        onChatClicked={(element) => onChatClicked(element)}
        disabledChat={true}
        isChat={false}
        onRequestStatusChanged={onRequestStatusChanged}
        setSearchValue={setSearchValue}
        searchLoading={loading}
      />
    </>
  );
};

export default ChatRequest;
